import { mapState, mapGetters } from 'vuex';
import coupon from '@mixins/officialWebStore/coupon';
import {
  SET_SHOW_CHANNEL_STATUS,
  SET_HAS_LOAD_PAYTYPE,
  UPDATE_LOADING,
  UPDATE_HAS_SELECT_PRODUCT
} from '@store/officialWebStore';
import { clickButton, locationType } from '@plugins/biPoint/_configWebstoreV2';
export default {
  mixins: [coupon],
  computed: {
    ...mapState({
      hasLoadPaytype: state => state.hasLoadPaytype,
      gameId: state => state.gameId
    }),
    ...mapGetters(['gameInfoConfig']),
    isCustomProductType() {
      return this.gameInfoConfig.isCustomProductType;
    },
    hasValidGameCoupon() {
      return this.gameCouponEnableList?.length > 0;
    }
  },
  methods: {
    handleReSelectProduct() {
      clickButton({
        btnName: 'back_select_product',
        locationKey: locationType.selectProduct
      });
      this.reSelectProduct();
    },
    reSelectProduct() {
      this.$store.commit(SET_HAS_LOAD_PAYTYPE, false);
      this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, false);
      this.$store.commit(UPDATE_LOADING, false);
      this.$store.commit(SET_SHOW_CHANNEL_STATUS, false);
      if (this.isCustomProductType) {
        this.$nextTick(() => {
          this?.initProductTypeExpand?.();
        });
      }
    }
  }
};
